var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-notification',{attrs:{"title":'מצאנו עוד חשבון בנק!',"text":'לדיוק התזרים, נצטרך לדעת האם להשאיר אותו כחלק מהתזרים או להתעלם ממנו.',"notification-buttons":[
                      {
                        title:'לדיוק התזרים!',
                        variant: 'primary',
                        action: _vm.openInvestigation,
                      } ],"icon-type":'warning'}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c2ac377","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/notification/notification-types/AccountQuestionsNotification.vue
// module id = null
// module chunks = 